import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setchallengePage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useChallengeSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getChallengeSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.challenge_page.challenge_section}`);
      console.log("🚀 ~ getChallengeSectionJson ~ data:", response);
      console.log("🚀 ~ getChallengeSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setchallengePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Challenge section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getChallengeSectionJson();
  }, [getChallengeSectionJson]);

  return {
    data,
    loading,
    error,
    getChallengeSectionJson,
    fetchOnMount,
    refetch: getChallengeSectionJson
  };
};

export default useChallengeSection;
